import React from 'react';
import { Box, Typography } from '@mui/material';

const GPAI: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        GPAI Testing Area
      </Typography>
      <Typography>
        This is where you can test the GPAI model.
      </Typography>
    </Box>
  );
};

export default GPAI;
